import {HttpRequest} from '../Data/HttpRequest'
import {server} from '../Data/BuildEnvironment'
import {PositionPatch} from '../Entities/PositionPatch'

export function batch(
    orderId: number,
    positionPatches: PositionPatch[],
    deletions: number[],
): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/orders/${orderId}/positions/batch`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({positionPatches, deletions}),
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/PositionResource.ts